/* eslint-disable */
export default function popin() {
  const isMobile = window.matchMedia("(max-width: 1023px)").matches;
  const popin = document.querySelector(".popin");
  const writeTo = document.querySelectorAll(".write-to");
  const brandEl = document.querySelector(".popin__brand");
  const brandTextEl = document.querySelector(".popin__fill-form-content");
  const closePopinBtn = document.querySelector(".popin__close-btn");
  const nextBrand = document.querySelector(".popin__brand-arrow-next");
  const prevBrand = document.querySelector(".popin__brand-arrow-prev");
  const copyTxtBtn = document.querySelector(".btn-copy-text");
  const goToFormBtn = document.querySelector(
    ".go-to-form .popin__fill-form-button"
  );
  const goToForm = document.querySelector(".go-to-form");
  const paperMailInput = document.querySelector(
    ".popin__paper-mail-input input"
  );
  const paperMailBtn = document.querySelector(".popin__paper-mail-button");
  const paperMailValidation = document.querySelector(
    ".popin__paper-mail-validation"
  );

  let indexBrand = 0;
  let brands;
  let idForm;

  if (popin && writeTo.length > 0 && !isMobile) {
    const initFetch = () => {
      fetch("/wp-json/wp/v2/pages/7")
        .then((response) => response.json())
        .then((data) => {
          brands = data.acf.brands;
          updateBrand();

          const changeBrand = (inc) => {
            indexBrand += inc;
            if (indexBrand < 0) {
              indexBrand = brands.length - 1;
            } else if (indexBrand > brands.length - 1) {
              indexBrand = 0;
            }
            goToForm.classList.remove(
              "popin__fill-form-button-wrapper--active"
            );

            paperMailValidation.style.display = "none";

            updateBrand();
          };

          nextBrand.addEventListener("click", () => changeBrand(1));
          prevBrand.addEventListener("click", () => changeBrand(-1));

          paperMailBtn.addEventListener("click", () => {
            const email = paperMailInput.value;

            grecaptcha.ready(() => {
              grecaptcha
                .execute("6LdtLQcrAAAAAJGupMv3vrCfifKIm5HDPz_QNijD", {
                  action: "contact_form",
                })
                .then((token) => {
                  const formData = new FormData();
                  formData.append("your-email", email);
                  formData.append("_wpcf7_unit_tag", `wpcf7-f${idForm}-p0-o1`);
                  formData.append("g-recaptcha-response", token);

                  fetch(
                    `/wp-json/contact-form-7/v1/contact-forms/${idForm}/feedback`,
                    {
                      method: "POST",
                      body: formData,
                    }
                  )
                    .then((response) => response.json())
                    .then((data) => {
                      if (data.status === "mail_sent") {
                        paperMailInput.value = "";
                        paperMailValidation.style.display = "block";
                      } else {
                        // Affiche un message d’erreur
                      }
                    })
                    .catch((err) => {
                      console.error("Erreur d’envoi CF7 :", err);
                    });
                });
            });
          });
        });
    };

    initFetch();

    const updateBrand = () => {
      brandEl.innerText = brands[indexBrand].brand__name;
      brandTextEl.innerText = brands[indexBrand].brand__text;
      goToFormBtn.href = brands[indexBrand]["brand__form-link"];
      idForm = brands[indexBrand]["brand__id-form"];
    };

    writeTo.forEach((write, i) => {
      write.addEventListener("click", (e) => {
        indexBrand = i;
        updateBrand();
        popin.classList.add("popin--active");
      });
    });

    closePopinBtn.addEventListener("click", () => {
      popin.classList.remove("popin--active");
      goToForm.classList.remove("popin__fill-form-button-wrapper--active");
      paperMailValidation.style.display = "none";
    });

    copyTxtBtn.addEventListener("click", () => {
      navigator.clipboard.writeText(brandTextEl.innerText).then(() => {
        goToForm.classList.add("popin__fill-form-button-wrapper--active");
      });
    });
  }

  const brandNameMobile = document.querySelector(".column-2__brand-name");
  const buttonContainers = document.querySelectorAll(
    ".column-2__button-container-title"
  );
  const fillFormTextMobile = document.querySelector(
    ".column-2__fill-form-text"
  );
  const goToFormMobile = document.querySelector(".go-to-form-mobile");
  const goToFormMobileBtn = document.querySelector(
    ".go-to-form-mobile .column-2__fill-form-button"
  );
  const copyTxtMobileBtn = document.querySelector(".btn-copy-text-mobile");

  const nextBrandMobile = document.querySelector(".column-2__next-brand svg");
  const prevBrandMobile = document.querySelector(".column-2__prev-brand svg");

  const paperMailMobileBtn = document.querySelector(
    ".column-2__paper-mail-button"
  );
  const paperMailMobileInput = document.querySelector(
    ".column-2__paper-mail-input input"
  );

  const paperMailValidationMobile = document.querySelector(
    ".column-2__paper-mail-validation"
  );

  if (isMobile && popin) {
    const initFetch = () => {
      fetch("/wp-json/wp/v2/pages/7")
        .then((response) => response.json())
        .then((data) => {
          brands = data.acf.brands;
          updateBrand();

          const changeBrand = (inc) => {
            indexBrand += inc;
            if (indexBrand < 0) {
              indexBrand = brands.length - 1;
            } else if (indexBrand > brands.length - 1) {
              indexBrand = 0;
            }
            goToFormMobile.classList.remove(
              "column-2__fill-form-button--active"
            );

            paperMailValidationMobile.style.display = "none";

            updateBrand();
          };

          nextBrandMobile.addEventListener("click", () => changeBrand(1));
          prevBrandMobile.addEventListener("click", () => changeBrand(-1));

          paperMailMobileBtn.addEventListener("click", () => {
            const email = paperMailMobileInput.value;
            paperMailMobileBtn.disabled = true;

            grecaptcha.ready(() => {
              grecaptcha
                .execute("6LdtLQcrAAAAAJGupMv3vrCfifKIm5HDPz_QNijD", {
                  action: "contact_form",
                })
                .then((token) => {
                  const formData = new FormData();
                  formData.append("your-email", email);
                  formData.append("_wpcf7_unit_tag", `wpcf7-f${idForm}-p0-o1`);
                  formData.append("g-recaptcha-response", token);

                  fetch(
                    `/wp-json/contact-form-7/v1/contact-forms/${idForm}/feedback`,
                    {
                      method: "POST",
                      body: formData,
                    }
                  )
                    .then((response) => response.json())
                    .then((data) => {
                      if (data.status === "mail_sent") {
                        paperMailMobileInput.value = "";
                        paperMailValidationMobile.style.display = "block";
                        paperMailMobileBtn.disabled = false;
                      } else {
                        // Affiche un message d’erreur
                      }
                    })
                    .catch((err) => {
                      console.error("Erreur d’envoi CF7 :", err);
                    });
                });
            });
          });
        });
    };

    initFetch();

    const updateBrand = () => {
      brandNameMobile.innerText = brands[indexBrand].brand__name;
      fillFormTextMobile.innerText = brands[indexBrand].brand__text;
      goToFormMobileBtn.href = brands[indexBrand]["brand__form-link"];
      idForm = brands[indexBrand]["brand__id-form"];
    };

    buttonContainers.forEach((bc) => {
      bc.addEventListener("click", () => {
        bc.classList.toggle("column-2__button-container-title--active");
      });
    });

    copyTxtMobileBtn.addEventListener("click", () => {
      navigator.clipboard.writeText(fillFormTextMobile.innerText).then(() => {
        goToFormMobile.classList.add(
          "column-2__fill-form-button-wrapper--active"
        );
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/popin.js